export default __webpack_public_path__ + "static/devprod-922b7c3490771abe21d57a4b8262d641.svg";